export default function MjmlHead() {
  return null;
}
